export default __webpack_public_path__ + "dd43ef708c340278d6907863125a2217.png";